import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BelenderRoutes } from 'src/app/belender/interfaces/belender-route.interface';
import { SupportNumberComponent } from './support-number.component';
import { QuicklinkModule } from 'ngx-quicklink';

const routes: BelenderRoutes = [
  {
    path: '',
    component: SupportNumberComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, QuicklinkModule]
})
export class SupportNumberRoutingModule {
}
